export enum UserManageMentSearchEnum {
  ALL = 'ALL',
  PUBLISHER = 'PUBLISHER',
  WRITER = 'WRITER',
  READER = 'READER',
  PAYMENT = 'PAYMENT',
  BAN = 'BAN',
}
